function initializeBraceSync(legOnlyMode) {
  console.log("🦿 Initializing brace sync...");

  function findBraceWrapper(labelText) {
    const legend = Array.from(document.querySelectorAll('fieldset legend'))
      .find(l => l.textContent.trim() === labelText);
    return legend?.closest('div')?.closest('div') || null;
  }

  const anchorWrapper = findBraceWrapper("Anchor Brace");
  const kneeWrapper = findBraceWrapper("Knee Brace");
  const braceSizeSelect = document.querySelector('select[name="properties[Brace Size]"]');
  const priceBlock = document.querySelector('#shopify-block-infinite_options_app_block_price_GFPyY6');

  // Only try to find the "Both Legs" field if not in leg_only_mode
  const bothLegsWrapperFull = legOnlyMode ? null : findBraceWrapper("Both Legs - Additional Braces");
  const bothLegsCheckbox = bothLegsWrapperFull?.querySelector('input[type="checkbox"]');

  if (!anchorWrapper || !kneeWrapper || !braceSizeSelect) {
    console.warn("❌ Required elements not found. Aborting.");
    return;
  }

  if (!legOnlyMode && !bothLegsWrapperFull) {
    console.warn("❌ Both Legs wrapper missing, but not in leg_only_mode. Aborting.");
    return;
  }

  if (priceBlock) {
    priceBlock.style.display = 'none';
    console.log("🙈 Price block hidden initially");
  }

  anchorWrapper.style.display = 'none';
  kneeWrapper.style.display = 'none';
  if (bothLegsWrapperFull) bothLegsWrapperFull.style.display = 'none';

  // Inject Injured Leg dropdown
  if (!document.querySelector('#injured-leg-select')) {
    const injuredLegWrapper = document.createElement('div');
    injuredLegWrapper.innerHTML = `
      <label for="injured-leg-select">Injured Leg</label>
      <select id="injured-leg-select">
        <option value="">Select</option>
        <option value="left">Left</option>
        <option value="right">Right</option>
        ${!legOnlyMode ? '<option value="both">Both</option>' : ''}
      </select>
    `;
    anchorWrapper.parentNode.insertBefore(injuredLegWrapper, anchorWrapper);
    console.log("✅ Injected Injured Leg dropdown");
  }

  const injuredLegSelect = document.querySelector('#injured-leg-select');
  const anchorFieldset = anchorWrapper.querySelector('fieldset');
  const kneeFieldset = kneeWrapper.querySelector('fieldset');

  function updateBraceCheckboxes(fieldset, leg, size) {
    const checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(cb => {
      if (cb.checked) cb.click();
    });

    if (!leg || !size) return;

    const matchValues = [];
    if (leg === 'left' || leg === 'both') matchValues.push(`Left / ${size}`);
    if (leg === 'right' || leg === 'both') matchValues.push(`Right / ${size}`);

    checkboxes.forEach(cb => {
      if (matchValues.includes(cb.value.trim()) && !cb.checked) {
        cb.click();
        console.log(`☑️ Clicked: ${cb.value}`);
      }
    });
  }

  function updateAllBraces() {
    const size = braceSizeSelect.value.trim();
    const leg = injuredLegSelect.value;

    let oppositeLeg;
    if (leg === "left") oppositeLeg = "right";
    else if (leg === "right") oppositeLeg = "left";
    else if (leg === "both") oppositeLeg = "both";
    else oppositeLeg = "";

    console.log(`🦿 Injured leg: ${leg}, Anchor brace: ${oppositeLeg}`);

    updateBraceCheckboxes(kneeFieldset, leg, size);
    updateBraceCheckboxes(anchorFieldset, oppositeLeg, size);

    // Only attempt to toggle the "Both Legs" checkbox if present
    if (!legOnlyMode && bothLegsCheckbox) {
      if (leg === "both" && !bothLegsCheckbox.checked) {
        bothLegsCheckbox.click();
        console.log("☑️ Checked: Both Legs - Additional Braces");
      } else if (leg !== "both" && bothLegsCheckbox.checked) {
        bothLegsCheckbox.click();
        console.log("🚫 Unchecked: Both Legs - Additional Braces");
      }
    }

    if (priceBlock) {
      if (leg === "left" || leg === "right" || (!legOnlyMode && leg === "both")) {
        priceBlock.style.display = "";
        console.log("💵 Showing price block");
      } else {
        priceBlock.style.display = "none";
        console.log("🙈 Hiding price block");
      }
    }
  }

  injuredLegSelect.addEventListener('change', updateAllBraces);
  braceSizeSelect.addEventListener('change', updateAllBraces);

  console.log("🚀 Brace sync initialized.");
}

const kneeBraceInURL = window.location.pathname.includes('knee-brace');

if(kneeBraceInURL){

  // Poll for Infinite Options and run when ready
  (function waitForInfiniteOptions() {
    const poller = setInterval(() => {
      const legOnlyMode = window.location.pathname.includes('leg-only');
  
      const braceSizeReady = document.querySelector('select[name="properties[Brace Size]"]');
      const anchorLegend = Array.from(document.querySelectorAll('fieldset legend'))
        .find(l => l.textContent.trim() === "Anchor Brace");
      const kneeLegend = Array.from(document.querySelectorAll('fieldset legend'))
        .find(l => l.textContent.trim() === "Knee Brace");
      const bothLegend = Array.from(document.querySelectorAll('fieldset legend'))
        .find(l => l.textContent.trim() === "Both Legs - Additional Braces");
  
      const allReady = braceSizeReady && anchorLegend && kneeLegend;
      const needsBothLegs = !legOnlyMode;
  
      const bothReady = needsBothLegs ? Boolean(bothLegend) : true;
  
      if (allReady && bothReady) {
        clearInterval(poller);
        console.log(`✅ Elements found — running initializeBraceSync() (leg_only_mode: ${legOnlyMode})`);
        initializeBraceSync(legOnlyMode);
      } else {
        console.log("⏳ Waiting for Infinite Options...");
      }
    }, 150);
  })();
}
else{
  console.log("Not a knee brace product, skip Infinite Options setup");
}
